























































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import DialogAI from "@/components/Dialog/Manual-AI.vue";
import BannerAi from "@/components/BannerAi.vue";

export default Vue.extend({
  data: () => ({
    drawer: false,
    dialog: false,
    family_site: ["채들관리자"],
    languages: [
      { text: "한국어(Korean)", value: "ko" },
      { text: "English", value: "en" },
    ],
  }),
  computed: {
    currentLanguage: {
      get(): string {
        return this.$i18n.locale;
      },
      set(lang: string): void {
        this.$i18n.locale = lang;
      },
    },
  },
  components: {
    BannerAi,
    DialogAI,
  },
});
